import React, { useEffect, useState } from 'react'
import plant from "../assets/img/vacspl/plant_small.jpeg";
import gun from "../assets/img/vacspl/gun1_small.jpeg";
import team from "../assets/img/vacspl/team_icon.png";
import spare from "../assets/img/vacspl/spare.jpg";
import credentials from "../assets/img/vacspl/credentials.jpeg";
import downloads from "../assets/img/vacspl/Downloads.png";
import quotation from "../assets/img/vacspl/quotation.png";
import gun_quotation_sheet from "../assets/img/vacspl/gun_quotation_sheet.webp";
import { useNavigate } from 'react-router';
import common from '../methods/common';
// import CONSTANTS from '../CONSTANTS';
// import sdsdf from "../"
// import  leads from "../database/leads_by_be.json"

const Home = () => {
    const [user, setUser] = useState({})
    const navigate = useNavigate();


    useEffect(() => {
        let u = localStorage.getItem('user');
        if (u) {
            common.refershLocalEmployee()
            u = JSON.parse(u);
            setUser(u);
        }
        // // leads.forEach(item=>item.QUERY_TIME && console.log(item.QUERY_TIME.slice(0,10)))
        // let obj={}
        // leads.forEach(item=>{
        //     if(!item.QUERY_TIME)return
        //     if(obj[item.QUERY_TIME.slice(0,10)]){
        //         obj[item.QUERY_TIME.slice(0,10)].push(item.SENDER_NAME)
        //     } else{
        //         obj[item.QUERY_TIME.slice(0,10)]=[];
        //         obj[item.QUERY_TIME.slice(0,10)].push(item.SENDER_NAME)
        //     }
        // })
        // console.log(obj)



    }, [])

    const handleLogout = () => {
        localStorage.clear()
        sessionStorage.clear()
    }

    const open = (slug) => {
        switch (slug) {
            case "service":
                navigate("/service")
                break;
            case "gun_quotation":
                navigate("/gunQuotation")
                break;
            case "reporting_sheets":
                navigate("/reportings")
                break;
            case "credentials":
                navigate("/credentials")
                break;
            case "lead-to-sheet":
                navigate("/lead-to-sheet")
                break;
            case "components_issue":
                navigate("/components-issue")
                break;
            case "quotations":
                navigate("/quotations")
                break;
            case "client_list":
                navigate("/client_list")
                break;
            case "service_report_list":
                navigate("/service_report_list")
                break;
            case "indiamart":
                navigate("/indiamart")
                break;
            case "imleads":
                navigate("/imleads")
                break;
            case "downloads":
                navigate("/downloads")
                break;
            case "dashboard":
                navigate("/dashboard")
                break;
            case "sparesold":
                navigate("/sparesold")
                break;
            case "emails":
                navigate("/emails")
                break;
            case "installationemails":
                navigate("/installationemails")
                break;
            case "testing":
                navigate("/testing")
                break;
            default:
                console.log("llii-----")
        }
    }

    // const share =()=>{
    //     if (navigator.share) {
    //         navigator.share({

    //             // Title that occurs over
    //             // web share dialog
    //             title: 'GeeksForGeeks',

    //             // URL to share
    //             url: 'https://geeksforgeeks.org'
    //         }).then(() => {
    //             console.log('Thanks for sharing!');
    //         }).catch(err => {

    //             // Handle errors, if occurred
    //             console.log(
    //             "Error while using Web share API:");
    //             console.log(err);
    //         });
    //     } else {

    //         // Alerts user if API not available
    //         alert("Browser doesn't support this API !");
    //     }
    // }

    // const handleOther=(slug)=>{
    //     switch (slug) {
    //         case "sent_quotation":
    //             console.log(CONSTANTS.GUN_QUOTATION_SENT_SHEET);
    //             // share()
    //             window.open(CONSTANTS.GUN_QUOTATION_SENT_SHEET, "_blank");
    //             break;
    //         default:
    //             console.log("llii-----")
    //     }
    // }

    return (
        <div className='home-page-widget'>
            <div className='features new'>
                {false && <div onClick={() => open("dashboard")}>
                    <img src={gun_quotation_sheet} alt="dashboard" />
                    <p>Dashboard</p>
                </div>}
                {user.Is_service_access ? <div onClick={() => open("service")}>
                    <img src={plant} alt="service" />
                    <p>Create Service Report</p>
                </div> : null}
                {user.Is_gun_quotation_access ? <div onClick={() => open("gun_quotation")}>
                    <img src={gun} alt="gun_quotation" />
                    <p>Generate Manual Gun Quotation</p>
                </div> : null}
                {user.team_reporting_sheets ? <div onClick={() => open("reporting_sheets")}>
                    <img src={team} alt="reporting_sheets" />
                    <p>Team Reporting Sheets</p>
                </div> : null}
                {user.is_admin ? <div onClick={() => open("credentials")}>
                    <img src={credentials} alt="reporting_sheets" />
                    <p>Credentials</p>
                </div> : null}
                {/* {user.is_admin ? <div onClick={() => open("lead-to-sheet")}>
                <img src={team} alt="lead-to-sheet" />
                <p>Lead To Sheet Management</p>
            </div> : null} */}
                <div onClick={() => open("quotations")}>
                    <img src={quotation} alt="reporting_sheets" />
                    <p>Gun Quotations Sent</p>
                </div>
                {/* {true ? <div onClick={() => open("components_issue")}>
                <img src={gun_quotation_sheet} alt="reporting_sheets" />
                <p>Compomnent & its Issues</p>
            </div> : null} */}
                {user.is_super_admin ? <div onClick={() => open("client_list")}>
                    <img src={gun_quotation_sheet} alt="client_list" />
                    <p>Client List</p>
                </div> : null}
                {user.first_name ? <div onClick={() => open("service_report_list")}>
                    <img src={gun_quotation_sheet} alt="service_report_list" />
                    <p>Servcice Reports List</p>
                </div> : null}
                {user.is_super_admin ? <div onClick={() => open("indiamart")}>
                    <img src={gun_quotation_sheet} alt="indiamart" />
                    <p>Indiamart</p>
                </div> : null}
                {user.is_super_admin ? <div onClick={() => open("imleads")}>
                    <img src={gun_quotation_sheet} alt="indiamart" />
                    <p>Indiamart lead</p>
                </div> : null}
                {user.first_name ? <div onClick={() => open("sparesold")}>
                    <img src={spare} alt="sparesold" />
                    <p>Spare</p>
                </div> : null}
                <div onClick={() => open("downloads")}>
                    <img src={downloads} alt="downloads" />
                    <p>Downloads</p>
                </div>
                <div onClick={() => open("emails")}>
                    <img src={downloads} alt="downloads" />
                    <p>Emails</p>
                </div>
                <div onClick={() => open("installationemails")}>
                    <img src={downloads} alt="installationemails" />
                    <p>installationemails</p>
                </div>
                {/* <div onClick={() => open("testing")}>
                <img src={gun_quotation_sheet} alt="downloads" />
                <p>Testing</p>
            </div> */}
            </div>
            <div className='logout' onClick={handleLogout}>Logout</div>
        </div>
    )
}

export default Home


